import axios from 'axios';

const api = axios.create({
  baseURL: 'http://localhost:8000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Network errors (no response received)
    if (error.code === 'ERR_NETWORK' || !error.response) {
      return Promise.reject('Check your privacy settings and internet connection. YouTube may think you are a bot.');
    }
    
    // Handle HTTP errors
    if (error.response) {
      return Promise.reject(error.response.data?.detail || 'Request failed');
    }
    
    return Promise.reject(error.message || 'An unknown error occurred');
  }
);

export const transcribeYouTube = (url: string) => api.post('/transcribe', { url });
export const analyzeTone = (samples: string[]) => api.post('/tone', { samples });
export const generateContent = (data: any) => api.post('/generate', data);

export default api;
